import { Platform } from 'react-native';
import { createTransform } from 'redux-persist';
import { resolveDefaultEnvironmentConfig, resolveStoreBuildNetworkFields, } from '../config/environment';
/**
 * Default network fields for the app slice (must match appSlice initial inference).
 * On web we do not persist frontend/backend URLs or environment so a stale test/prod
 * origin cannot break React Navigation linking on localhost after rehydrate.
 */
export function getDefaultAppNetworkFields() {
    return resolveDefaultEnvironmentConfig();
}
export function replacePersistedNetworkFields(outbound, defaults) {
    return { ...outbound, ...defaults };
}
/**
 * Store builds rehydrate production unless the saved email is an allowed `test$` (koutavasj) email.
 * Web keeps the host-based default and does not honor email prefixes.
 */
export function rehydratePersistedAppState(outbound, storeBuild = __STORE_BUILD__) {
    if (storeBuild) {
        const email = typeof outbound.email === 'string' ? outbound.email : '';
        return replacePersistedNetworkFields(outbound, resolveStoreBuildNetworkFields(email));
    }
    return replacePersistedNetworkFields(outbound, getDefaultAppNetworkFields());
}
export const webAppEnvStripTransform = createTransform((inbound) => {
    if (Platform.OS !== 'web' && !__STORE_BUILD__) {
        return inbound;
    }
    const next = { ...inbound };
    delete next.frontendBaseUrl;
    delete next.backendBaseUrl;
    delete next.environment;
    return next;
}, (outbound) => {
    if (Platform.OS !== 'web' && !__STORE_BUILD__) {
        return outbound;
    }
    return rehydratePersistedAppState(outbound);
}, { whitelist: ['app'] });
